import { ActivatedRouteSnapshot } from '@angular/router';

/** A path parameter from this route or any ancestor — `:studyId` sits above the unit routes. */
export function routeParamFromRoot(route: ActivatedRouteSnapshot, name: string): string | undefined {
  for (const snapshot of route.pathFromRoot) {
    const value: unknown = snapshot.params[name];
    if (typeof value === 'string' && value) {
      return value;
    }
  }
  return undefined;
}
